import { Utils } from 'app/utils/utils';

export type ConfigurationItemListOptionsSort = 'name' | 'date';
export type ConfigurationItemListOptionsFilter = 'both' | 'name' | 'query';

export interface IConfigurationItemListOptions {
  sort: ConfigurationItemListOptionsSort;
  filter: ConfigurationItemListOptionsFilter;
  showHidden: boolean;
}

export class ConfigurationItemListOptions implements IConfigurationItemListOptions {
  sort: ConfigurationItemListOptionsSort;
  filter: ConfigurationItemListOptionsFilter;
  showHidden: boolean;

  constructor(
    sort: ConfigurationItemListOptionsSort,
    filter: ConfigurationItemListOptionsFilter,
    showHidden: boolean
  ) {
    this.sort = sort;
    this.filter = filter;
    this.showHidden = showHidden;
  }

  static create(): ConfigurationItemListOptions {
    return new ConfigurationItemListOptions('name', 'both', false);
  }

  equals(options: ConfigurationItemListOptions): boolean {
    return Utils.deepEquals(this, options);
  }
}
